import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { workOrdersRestCrudThunksForBuyer } from '../../thunks/work_orders_thunks';
import { EditPage } from '../edit_page/EditPage';
import WorkOrderEditSafeForm from '../work_order_edit_safe_form/WorkOrderEditSafeForm';
import { goBackLink, recursiveRemovePreserve } from '../../utils/HistoryUtils';
import { getWorkOrderSelector } from '../../selectors/workOrderSelectors';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { getEntityById } from '../../utils/DataAccessUtils';

const style = require('./EditSafeWorkOrderPage.less');
const queryString = require('qs');

class EditSafeWorkOrderPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
		this.state = {
			fetching: true,
		};
	}

	componentDidMount() {
		const { getWorkOrder, match } = this.props;
		const workOrderId = match.params.id;
		getWorkOrder(workOrderId).then(() => {
			this.setState({ fetching: false });
		});
	}

	render() {
		const { history, workOrder, location } = this.props;
		const { fetching } = this.state;
		const defaultUrlPath = `/buyer/workOrders/detail/${workOrder.id}/details`;

		return fetching ? (
			<PageLoadingPlaceholder />
		) : (
			<EditPage
				title="Edit Work Order"
				formComponentProps={{
					formData: workOrder,
					isApprovalForm: false,
					onSuccess: (rec) => {
						let string = goBackLink(location, defaultUrlPath);
						const [path, queryParams] = string.split('?');
						let urlSearchParams = queryString.parse(queryParams);
						history.push(`${path}?${recursiveRemovePreserve(urlSearchParams)}`);
					},
				}}
				fetching={fetching}
				FormComponent={WorkOrderEditSafeForm}
			/>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		history: ownProps.history,
		workOrder: getEntityById(ownProps.match.params.id, state.work_orders),
		fetching: state.work_orders.fetching,
		match: ownProps.match,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getWorkOrder: (id) => dispatch(workOrdersRestCrudThunksForBuyer.readOne(id)),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(EditSafeWorkOrderPage)
);
